import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { StackSettingsContextData } from "views/Stack/Settings/Context";

import { WebhookIntegrationWithTimestamp } from "../types";

const StackWebhooksTableEndpointCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<WebhookIntegrationWithTimestamp>) => {
  const { stackSettings } = useTypedContext(StackSettingsContextData);

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink
        href={`/stack/${stackSettings.id}/settings/integrations/webhook/${webhook.id}`}
      >
        {webhook.endpoint}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default StackWebhooksTableEndpointCell;
